// extracted by mini-css-extract-plugin
export var cardContainer = "_qk-0";
export var cardHeader = "_qk-2";
export var collapsedState = "_qk-3";
export var dragHandle = "_qk-5";
export var dragHandleIcon = "_qk-6";
export var dragging = "_qk-1";
export var titleArea = "_qk-4";